import * as dataUtils from '../utils/dataUtils';

import debounce from '../utils/debounce';
import sessionStorageService from '../services/DataStorageService/SessionStorageService';


const STORE_KEY = 'store';


/**
 * Writes store state to session storage for reload support.
 * Only root state objects with the property _synced: true are being persisted, e.g.
 * <code>
 *     {
 *         rootReducerKey1: {
 *             subState: {}
 *         },
 *         rootReducerKey2: {
 *             _synced: true,
 *             subState: {}
 *         }
 *     }
 * </code>
 *
 * @type {(function(...[*]): void)|*}
 */
export const saveFromStore = debounce(store => {

    const state = store.getState();
    const stateToSave = dataUtils.filter(state, (rootReducerKey, subState) => subState._synced === true);
    if (!dataUtils.isEmpty(stateToSave)) {
        sessionStorageService.set(STORE_KEY, stateToSave);
    }
});



export const syncToStore = () => {

    return sessionStorageService.get('store', {});
};
